import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Table } from "reactstrap";
import moment from "moment";
import axios from "axios";
import mapboxgl from "mapbox-gl";
import polyline from "@mapbox/polyline";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";

import Form from "../../../general/Form/Form";
import classes from "./TruckRouteHistoryModal.module.scss";

const initialState = {
  campaignName: "",
  startDate: "",
  endDate: "",
  mileage: 0,
  coordinates: [],
  loadedRouteHistory: false
};

class TruckRouteHistoryModal extends Component {
  state = initialState;

  map = null;
  layerIds = [];
  mapRef = React.createRef();

  toggle = () => {
    // this.removeRoutes(this.map);
    this.setState(initialState);
    this.props.toggleModal();
  };

  componentDidUpdate = async () => {
    if (this.props.data.id && this.props.data.startDate && this.props.data.endDate && !this.state.loadedRouteHistory) {
      console.log("load");
      let startDate = moment(this.props.data.startDate).format("YYYY-MM-DD");
      let endDate = moment(this.props.data.endDate).format("YYYY-MM-DD");
      let res = await axios.get(
        `${process.env.REACT_APP_API_HOST}/truck/${this.props.data.id}/routes?start_date=${startDate}&end_date=${endDate}`,
        { withCredentials: true }
      );
      if (res.status === 200 && res.data.truck) {
        let mileage = 0;
        let coordinates = [];
        res.data.truck.map((route) => {
          mileage += route.distance;
          return polyline.decode(route.polyline).map((point) => coordinates.push(point.reverse()));
        });
        this.setState({
          loadedRouteHistory: true,
          coordinates: coordinates,
          mileage: mileage
        });
      }
    }
    if (this.state.loadedRouteHistory && this.mapRef) {
      if (!this.map) {
        mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
        // intial map setup
        const map = new mapboxgl.Map({
          container: this.mapRef,
          style: "mapbox://styles/mapbox/light-v9",
          center: [-118.15698, 33.95041],
          zoom: 9,
          minZoom: 5,
          maxZoom: 15
        });

        const nav = new mapboxgl.NavigationControl();
        map.addControl(nav, "bottom-right");
        this.map = map;
      }
      this.map.on("load", () => {
        this.drawRoute();
      });
    }
  };

  drawRoute = () => {
    let map = this.map;
    this.removeRoutes(map);
    let layerId = `${this.props.data.id}-route`;
    this.layerIds.push(layerId);
    map.addLayer({
      id: layerId,
      type: "line",
      source: {
        type: "geojson",
        data: {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: this.state.coordinates
          }
        }
      },
      layout: {
        "line-join": "round",
        "line-cap": "round"
      },
      paint: {
        "line-color": "#00210b",
        "line-width": 5,
        "line-opacity": 0.125
      }
    });
    // set map bounds to line string
    let firstCoord = this.state.coordinates[0];
    let bounds = this.state.coordinates.reduce(
      (bounds, coord) => bounds.extend(coord),
      new mapboxgl.LngLatBounds(firstCoord, firstCoord)
    );
    map.fitBounds(bounds, {
      padding: 20
    });
  };

  removeRoutes = (map) => {
    this.layerIds.map((layerId) => {
      if (map.getLayer(layerId)) {
        map.removeLayer(layerId);
        map.removeSource(layerId);
      }
    });
  };

  render() {
    return (
      <Modal isOpen={this.props.show} toggle={this.toggle} size="xl">
        <ModalHeader toggle={this.toggle}>{this.props.name} Route History</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <Table>
                <thead>
                  <tr>
                    <th>Campaign Name</th>
                    <th>Track Only</th>
                    <th>Tracking Start Date</th>
                    <th>Tracking End Date</th>
                    <th>Mileage</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{this.props.data.name}</td>
                    <td>{this.props.data.tracking}</td>
                    <td>{this.props.data.startDate}</td>
                    <td>{this.props.data.endDate}</td>
                    <td>{this.state.mileage}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row>
            <Col>
              <div id="map" className={classes.map} ref={(el) => (this.mapRef = el)} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default TruckRouteHistoryModal;
